import { Vue, Prop, Watch, Component } from 'vue-property-decorator';
import moment from 'moment';
import type { ElForm } from 'element-ui/types/form';
import { toSafeInteger } from 'lodash';
import ExportFile from '../exportFile';
import batchAdd from './batchAdd';
import style from './style.vue';
import couponsList from './productEnableCouponsList';
import { IPSService } from '@/services/ipsServices';
import ChooseGoodsClass from '@/views/components/chooseGoodsClass';
import { noop } from '@/util';
import bindClassDialog from '@/views/components/newDisplayConfig/bindClassDialog';
import cornerDialog from '@/views/components/cornerDialog';
import GenerateLink from '@/views/components/generateLink';
import UpdatePrice from '@/views/components/updatePrice/updatePrice';

export enum State_TYPE {
  DISABLED, // 已下架
  ON_SALE, // 销售中
  SALL_OUT, // 已售罄
}
export enum AState_TYPE {
  MANUAL, // 手工
  AUTO, // 系统
}
export enum STATE_ON {
  OFF, // 下架
  ON, // 上架
}
const PState = {
  [State_TYPE.ON_SALE]: '销售中',
  [State_TYPE.SALL_OUT]: '已售罄',
  [State_TYPE.DISABLED]: '已下架',
};
const AState = {
  [AState_TYPE.MANUAL]: '手工',
  [AState_TYPE.AUTO]: '系统',
};
const BState = {
  [STATE_ON.OFF]: '下架',
  [STATE_ON.ON]: '上架',
};
enum SORT_TYPE {
  UDATE_TIME, // 更新时间倒叙
  ORIGIN_PRICE_DESC, // 牌价倒叙
  ORIGIN_PRICE_ASC, // 牌价正序
  PRICE_DESC, // 现价倒叙3
  PRICE_ASC, // 现价正序4
  STOCK_DESC, // 库存倒叙5
  STOCK_ASC, // 库存正序6
  SALE_DESC, // 销量倒叙7
  SALE_ASC, // 销量正序8
  COUPON_DESC, // 优惠券倒序9
  COUPON_ASC, // 优惠券正序10
  TAG_ASC, // 角标正序11
  TAG_DESC, // 角标倒序12
  CHANGE_STATE_TIME_ASC, // 上下架时间正序13
  CHANGE_STATE_TIME_DESC, // 上下架时间倒叙14
  UPDATE_TIME_ASC, // 更新时间正序
}

interface SiteProduct {
  productId?: number; // 商品自增Id
  productName?: string; // 商品名称
  productImage?: string; // 商品图片
  productCode?: string; // 货号
  originPrice?: number; // 原价
  price?: number; // 现价
  stock?: number; // 库存
  changeStatePerson: string; // 上下架操作者
  changeStateTime: number; // 上下架时间
  isLine: number; // 上下架状态
  empCode: string; // 更新人编号
  updatePerson: string; // 更新人名称
  saleNum?: number; // 销量
  productState?: 0 | 1 | 2; // 商品状态 0 已下架 1 销售中 2 已售罄
  updateTime?: number; // 更新时间
}
// 位置 1左上 2右上 3左下 4右下 5底部
export enum TAG_PLACE {
  TOP_LEFT = 1,
  TOP_RIGHT,
  BOTTOM_LEFT,
  BOTTOM_RIGHT,
  BOTTOM_CENTER,
}

@Component({
  mixins: [style],
	components: {
		ExportFile
	},
})
export default class ProductList extends Vue {
  // 商品状态 9 全部 1 销售中  2 已售罄 3 已下架
  @Prop({ default: 9 })
    pType: number;

  @Prop()
    propKeyword: string;

  @Prop()
    propPage: number;

  @Prop()
    propPageSize: number;

  @Prop()
    propSort: number;

  @Prop()
    siteId: number;

  // 索引
  $refs: {
    pTable: ElForm;
  };

  // 页码
  page = 1;

  //  每页显示数量
  pageSize = 10;

  //  总数
  totalCount = 0;

  //  搜索关键字
  keyword = '';

  // 加载状态
  loadingState = false;

  // 商品列表
  pData: SiteProduct[] = [];

  // 选中项
  tableSelected = [];

  // 升序 或 降序
  sortBy = 0;

  // 筛选
  newTagArr: Array<any> = [];

  // 选中标签的id
  selectTags: Array<any> = [];

  // 默认选中的
  selectedKeys: Array<any> = [];

  // 上下架类型筛选

  typeOfChangeState = null;

  option = [
    {
      value: 3,
      label: '系统上架',
    },
    {
      value: 4,
      label: '系统下架',
    },
    {
      value: 1,
      label: '手工上架',
    },
    {
      value: 2,
      label: '手工下架',
    },
  ];

  /**
   * 绑定主档分类弹窗是否显示
   * @type {boolean}
   */
  public isBindMainVisible = false;

  @Watch('pType', { immediate: true, deep: true })
  watchType(n, o) {
    if (o) {
      // @ts-expect-error
      this.$refs.pTable.clearSort();
    }
    this.sortBy = this.propSort;
    this.page = this.propPage;
    this.pageSize = this.propPageSize;
    this.keyword = this.propKeyword;
    this.getData();
  }

  @Watch('sortBy', { deep: true })
  sortWatch(n) {
    this.$emit('sortChange', n);
  }

  @Watch('page', { deep: true })
  pagetWatch(n) {
    this.$emit('pageChange', n);
  }

  @Watch('pageSize', { deep: true })
  pageSizeWatch(n) {
    this.$emit('pageSizeChange', n);
  }

  @Watch('keyword', { deep: true })
  keywordWatch(n) {
    this.$emit('keywordChange', n);
  }

  get exportParams() {
    const productIds = this.tableSelected.map(v => v.productId);
    const postParams = {
      exportType: 'productList',
      params: { siteId: this.siteId, keyword: this.keyword, productState: this.pType, sort: this.sortBy, attrValueList: this.selectTags, productIds, stateType: this.typeOfChangeState },
    };

    return postParams;
  }

  onPageChange(val) {
    this.page = val;
    this.getData();
  }

  onPageSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getData();
  }

  onSortChange(column) {
    switch (column.prop) {
      case 'originPrice':
        this.sortBy = column.order === 'ascending' ? SORT_TYPE.ORIGIN_PRICE_ASC : SORT_TYPE.ORIGIN_PRICE_DESC;
        break;
      case 'price':
        this.sortBy = column.order === 'ascending' ? SORT_TYPE.PRICE_ASC : SORT_TYPE.PRICE_DESC;
        break;
      case 'stock':
        this.sortBy = column.order === 'ascending' ? SORT_TYPE.STOCK_ASC : SORT_TYPE.STOCK_DESC;
        break;
      case 'saleNum':
        this.sortBy = column.order === 'ascending' ? SORT_TYPE.SALE_ASC : SORT_TYPE.SALE_DESC;
        break;
      case 'couponNum':
        this.sortBy = column.order === 'ascending' ? SORT_TYPE.COUPON_ASC : SORT_TYPE.COUPON_DESC;
        break;
      case 'tagNum':
        this.sortBy = column.order === 'ascending' ? SORT_TYPE.TAG_ASC : SORT_TYPE.TAG_DESC;
        break;
      case 'changeStateTimeStr':
        this.sortBy = column.order === 'ascending' ? SORT_TYPE.CHANGE_STATE_TIME_ASC : SORT_TYPE.CHANGE_STATE_TIME_DESC;
        break;
      case 'updateTimeStr':
        this.sortBy = column.order === 'ascending' ? SORT_TYPE.UPDATE_TIME_ASC : SORT_TYPE.UDATE_TIME;
        break;
      default:
        this.sortBy = SORT_TYPE.UDATE_TIME;
        break;
    }
    this.getData();
  }

  // 编辑
  onEdit(productId) {
    this.$emit('edit', productId);
  }

  /**
   * 修改状态
   * @param productId
   * @param openState 0 下架 1 上架
   */
  updateState(productId, openState) {
    openState ? this.onEnable(productId, openState) : this.onDisabled(productId, openState);
  }

  // 上架
  onEnable(productId, openState) {
    this.batchUpdateState(openState, [productId]);
  }

  // 下架
  onDisabled(productId, openState) {
    this.$confirm('确定将当前商品下架？', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.batchUpdateState(openState, [productId]);
      }
    }, noop);
  }

  /**
   * 批量上下架
   * @param productId
   * @param openState 0 下架 1 上架
   */
  batchAble(openState, productIds) {
    this.$confirm(`确定将选中的${productIds.length}件商品${openState ? '上架' : '下架'}处理?`, {
      type: 'warning',
    }).then((result) => {
      if (result === 'confirm') {
        this.batchUpdateState(openState, productIds);
      }
    });
  }

  // 删除
  onDel(productId, openState = -1) {
    this.$confirm('确定将当前商品删除？', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.batchUpdateState(openState, [productId]);
      }
    }, noop);
  }

  /**
   * 批量修改状态
   * @param openState  0 下架 1 上架 - 1 删除
   * @param productIds
   * @returns null
   */
  batchUpdateState(openState, productIds = null): void {
    if (!productIds) {
      productIds = this.tableSelected.map(v => v.productId);
    }
    IPSService.siteProductState({
      postParams: {
        openState,
        productIds: productIds || this.tableSelected.map(v => v.productId),
        siteId: this.siteId,
      },
    }).then(() => {
      this.$message.success('操作成功');
      if (openState === -1) {
        this.page = 1;
      }
      this.getData();
    });
  }

  // 选中
  onSelected(val) {
    this.tableSelected = val;
  }

  //   刷新
  onFresh(productCodes = []) {
    IPSService.siteProductStock({
      postParams: {
        productCodes: productCodes.join(','),
        siteId: this.siteId,
      },
    }).then(() => {
      this.$message.success('同步成功');
      this.getData();
    });
  }

  // 批量添加
  batchAdd() {
    batchAdd
      .open({
        path: this.$route.path,
        urlPrams: this.$route.params,
        importUrl: '/admin/add/product/import',
        importParams: { siteId: this.siteId },
        title: '批量添加商品',
        siteId: this.siteId,
      })
      .then((result) => {
        this.getData();
      }, noop);
  }

  batchOnShelves() {
    batchAdd
      .open({
        path: this.$route.path,
        urlPrams: this.$route.params,
        importUrl: '/admin/add/product/import',
        state: 1,
        title: '批量商品上下架',
        importParams: { siteId: this.siteId },
        siteId: this.siteId,
      })
      .then((result) => {
        this.getData();
      }, noop);
  }

  // 批量删除
  batchDel() {
    if (!this.tableSelected || !this.tableSelected.length) {
      return;
    }
    this.$confirm(`确认将当前选中的${this.tableSelected.length}件商品删除？`, { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.batchUpdateState(-1);
      }
    });
  }

  // 更新商品价格
  updateProduct() {
    const itemArr = this.tableSelected.map((item) => {
      return item.productCode;
    });
    const item = itemArr.toString();
    const siteId = this.siteId;
    UpdatePrice.open({
      item,
      siteId,
      title: '更新商品价格',
    }).then(() => {
      this.getData();
    }, noop);
  }

  // 获取数据
  getData() {
    const loading = this.$loading({
      lock: true,
      text: '请稍等...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
      target: '.categoryConfig',
    });
    const postParams = {
      siteId: this.siteId,
      keyword: this.keyword,
      productState: this.pType,
      page: this.page,
      pageSize: this.pageSize,
      sort: this.sortBy,
      attrValueList: this.selectTags,
      stateType: this.typeOfChangeState,
      // 这里还要加一个上下架筛选
    };

    IPSService.siteProductList({
      postParams,
    }).then(
      (response) => {
        loading.close();
        this.totalCount = response.count || 0;
        this.pData = response.list.map((v) => {
          return Object.assign({}, v, {
            updateTimeStr: moment(v.updateTime * 1000).format('YYYY-MM-DD HH:mm'),
            changeStateTimeStr: moment(v.changeStateTime * 1000).format('YYYY-MM-DD HH:mm'),
            stateStr: PState[v.productState || 0],
            LineStr: AState[v.isLine] + BState[v.state],
          });
        });
      },
      () => {
        loading.close();
      },
    );
  }

  // 批量同步库存
  batchStock() {
    const codes = this.pData.map(v => v.productCode);
    this.onFresh(codes);
  }

  // 打开筛选分类弹窗
  openFilter() {
    // 获取总分类
    return IPSService.classFilterList({
      postParams: {
        sgId: +this.$route.params.sgId,
      },
    })
      .then((response) => {
        return response.list;
      })
      .then((res) => {
        bindClassDialog
          .open({
            defaultCheckedKeys: this.selectedKeys,
            dataSource: res,
            props: { children: 'children', label: 'className' },
            nodeKey: 'classId',
            title: '高级筛选',
            formTitle: '请选择一级筛选项',
            tips: '',
          })
          .then((result) => {
            // 定义一个空数组，通过双重遍历，把选中的类转成二维数组
            const newTags = [];
            res.map((item, index) => {
              result.map((citem, cindex) => {
                if (citem.parentId == item.value_no) {
                  if (!Array.isArray(newTags[index])) {
                    newTags[index] = [];
                    newTags[index].fatherName = item.value_name;
                    newTags[index].children = [];
                  }
                  newTags[index].children.push(citem);
                  this.newTagArr = newTags;
                }
              });
            });
            // 定义一个空数组，通过双重遍历，筛选出已选类型的 id
            const selectTags = [];
            newTags.map((item, index) => {
              const arrs = [];
              item.children.map((citem, cindex) => {
                arrs.push(citem.vAttributeValue);
              });
              const str = arrs.join(',');
              selectTags.push(str);
            });

            // 定义一个空数组，用来存放已选中的类型
            const selectedKeys = [];
            newTags.map((item, index) => {
              item.children.map((citem, cindex) => {
                selectedKeys.push(citem.classId);
              });
            });
            this.selectedKeys = selectedKeys;

            this.selectTags = selectTags;
            this.page = 1;
            this.getData();
            this.isBindMainVisible = false;
          }, noop);
      });
  }

  // 打开角标预览弹层
  openTagDialog(id, image) {
    const params = {
      siteId: Number(this.$route.params.siteId),
      productId: id,
    };
    // TODO: 在之前的基础上改了，需后续重构 （如果有后续的话）
    let left: any = null;
    let right: any = null;
    let bottom: any = null;

    IPSService.productMappingTagList({ postParams: params })
      .then((res) => {
        res.list
          && res.list.map((item, index) => {
            if (item.tagPlace == TAG_PLACE.TOP_LEFT) {
              if (left) {
                if (item.updateTime > left.updateTime) {
                  left = item;
                }
              } else {
                left = item;
              }
            } else if (item.tagPlace == TAG_PLACE.TOP_RIGHT) {
              if (right) {
                if (item.updateTime > right.updateTime) {
                  right = item;
                }
              } else {
                right = item;
              }
            } else if (item.tagPlace === TAG_PLACE.BOTTOM_CENTER) {
              if (bottom) {
                if (item.updateTime > bottom.updateTime) {
                  bottom = item;
                }
              } else {
                bottom = item;
              }
            }
          });
      })
      .then((res) => {
        cornerDialog
          .open({
            left,
            right,
            bottom,
            image,
            siteId: this.$route.params.siteId,
            productId: id,
          })
          .then(noop);
      });
  }

  onSearch() {
    this.page = 1;
    this.getData();
  }

  onSearchState() {
    this.page = 1;
    this.getData();
  }

  // 批量设置分类
  batchSetClass() {
    if (!this.tableSelected || !this.tableSelected.length) {
      return;
    }
    ChooseGoodsClass.open({ siteId: this.siteId, selectType: 2 }).then((result) => {
      IPSService.siteProductClassUpdate({
        postParams: {
          siteId: this.siteId,
          productIds: this.tableSelected.map(v => v.productId),
          classIds: result,
        },
      }).then((response) => {
        this.getData();
      });
    }, noop);
  }

  // 删除筛选标签
  deleteTag() {
    this.newTagArr = [];
    this.selectTags = [];
    this.selectedKeys = [];
    this.getData();
  }

  // 查看该商品可用优惠券列表
  productCouponsList(productId) {
    couponsList.open({ productId, siteId: this.siteId }).then(noop, noop);
  }

  link(item) {
    GenerateLink.open({
      item,
      type: 'goods',
      title: '生成商品链接',
      confirm: false,
      remarkList: ['注1：此链接可用于直播间商品链接使用，点击直播商品可跳转到商城的商品详情；'],
    }).then(noop, noop);
  }

  renderTableBtn(h, val) {
    const { productState, operAuth, productId } = val;
    return (
      <div>
        <span class="scopeSpan" onClick={this.onEdit.bind(this, productId)}>
          编辑
        </span>
        <span class="scopeSpan" onClick={this.updateState.bind(this, productId, productState === 0 ? 1 : 0)}>
          {productState === 0 ? '上架' : '下架'}
        </span>
        <span class="scopeSpan" onClick={this.link.bind(this, val)}>
          链接
        </span>
        <span class="scopeSpan" onClick={this.onDel.bind(this, productId, -1)}>
          删除
        </span>
      </div>
    );
  }

  uploadExcel() {
    console.log('运维老哥稳');
    batchAdd
      .open({
        path: this.$route.path,
        urlPrams: this.$route.params,
        importUrl: '/admin/sync/product/import',
        siteId: this.siteId,
        isNormal: false,
        title: '运维入口，请慎用',
      })
      .then((result) => {
        this.getData();
      }, noop);
  }

  render(h) {
    return (
      <div class="p-list">
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keyword} placeholder="商品货号/商品名称/上下架操作者/更新人" />
            <i class="iconfont iconsousuo" onClick={this.onSearch.bind(this)} />
          </div>
          <div>
            <el-select placeholder="上下架类型" v-model={this.typeOfChangeState} clearable onChange={this.onSearchState.bind(this)}>
              {this.option.map((item) => {
                return <el-option value={item.value} label={item.label}></el-option>;
              })}
            </el-select>
          </div>
          <div class="inputWrapper1">
            <div class="filterType">
              <el-button type="text" onClick={this.openFilter.bind(this)}>
                高级筛选
              </el-button>
              <div class="tagslist">
                <div class="tagbox">
                  {this.newTagArr.map((item, index) => {
                    return (
                      <div class="content">
                        <div>
                          {item.fatherName}-
                          {item.children.map((citem, cindex) => {
                            return (
                              <span>
                                {citem.className}
                                {cindex === item.children.length - 1 ? '' : '、'}
                              </span>
                            );
                          })}
                          ;
                        </div>
                      </div>
                    );
                  })}
                  {this.newTagArr.length > 0 ? <i class="el-icon-delete delete" onClick={this.deleteTag.bind(this)}></i> : ''}
                </div>
              </div>
            </div>
          </div>
          <div class="inputWrapper">
            <el-button type="primary" class="hidden" onClick={() => this.uploadExcel()}>
              运维专用
            </el-button>
            <el-button type="primary" onClick={() => this.$emit('edit')}>
              添加单件商品
            </el-button>
            <el-button type="primary" onClick={this.batchAdd.bind(this)}>
              批量添加商品
            </el-button>
            <el-button type="primary" onClick={this.batchOnShelves.bind(this)}>
              批量商品上下架
            </el-button>
            <el-button type="primary" onClick={this.batchStock.bind(this)}>
              批量同步本页库存
            </el-button>
          </div>
        </div>

        <div class="tableWrapper width-100">
          <el-table ref="pTable" data={this.pData} v-loading={this.loadingState} height={'calc(100% - 91px)'} on-sort-change={this.onSortChange.bind(this)} on-selection-change={this.onSelected} element-loading-text="加载中" tooltip-effect="light">
            <el-table-column type="selection" width="55px" align="center" fixed="left" />
            <el-table-column type="index" label="#" width="55" align="left" fixed="left" />
            <el-table-column
              prop=""
              label="商品"
              align="left"
              width="220"
              fixed="left"
              show-overflow-tooltip={true}
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return (
                      <div class="p-info" onClick={this.onEdit.bind(this, scope.row.productId)}>
                        <img class="p-pic" src={scope.row.productImage} />
                        {/* <el-tooltip class="item" effect="light" content={scope.row.productName} placement="top"> */}
                        <div class="p-name">{scope.row.productName}</div>
                        {/* </el-tooltip> */}
                      </div>
                    );
                  },
                },
              }}
            />
            <el-table-column prop="productCode" label="货号" width="120" align="left" show-overflow-tooltip={true} />
            <el-table-column
              prop="originPrice"
              label="牌价(元)"
              align="right"
              header-align="right"
              width="120"
              sortable
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <span>￥{scope.row.originPrice != scope.row.maxOriginPrice ? `${Math.min(scope.row.maxOriginPrice, scope.row.originPrice)}~￥${Math.max(scope.row.maxOriginPrice, scope.row.originPrice)}` : scope.row.originPrice}</span>;
                  },
                },
              }}
            />
            <el-table-column
              prop="price"
              label="现价(元)"
              align="right"
              header-align="right"
              width="120"
              sortable
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <span>￥{scope.row.maxPrice != scope.row.price ? `${Math.min(scope.row.price, scope.row.maxPrice)}~￥${Math.max(scope.row.price, scope.row.maxPrice)}` : scope.row.price}</span>;
                  },
                },
              }}
            />
            <el-table-column
              prop="couponNum"
              label="可用券"
              header-align="right"
              align="right"
              width="120px"
              sortable
              show-overflow-tooltip
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return (
                      <span class="scopeSpan q-link" onClick={this.productCouponsList.bind(this, scope.row.productId)}>
                        {scope.row.couponNum || 0}
                      </span>
                    );
                  },
                },
              }}
            />
            <el-table-column
              prop="stock"
              label="库存"
              header-align="right"
              align="right"
              width="120px"
              show-overflow-tooltip
              sortable
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return (
                      <span>
                        {scope.row.stock}&nbsp;
                        <i class="el-icon-refresh-right  font-size-20 relative-position cursor-pointer text-blue-15 top-2" onClick={this.onFresh.bind(this, [scope.row.productCode])}></i>
                      </span>
                    );
                  },
                },
              }}
            />
            <el-table-column prop="saleNum" label="销量" header-align="right" align="right" width="100px" sortable />
            <el-table-column
              prop="tagNum"
              label="角标"
              header-align="right"
              align="right"
              sortable
              show-overflow-tooltip
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return (
                      <span class="scopeSpan q-link" onClick={this.openTagDialog.bind(this, scope.row.productId, scope.row.productImage)}>
                        {scope.row.tagNum}
                      </span>
                    );
                  },
                },
              }}
            />
            <el-table-column
              prop="stateStr"
              label="商品状态"
              align="center"
              width="120px"
              show-overflow-tooltip
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <div class="rp-r-0">{scope.row.stateStr}</div>;
                  },
                },
              }}
            />
            <el-table-column
              prop="changeStatePerson"
              label="上下架操作者"
              align="center"
              width="120px"
              show-overflow-tooltip
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <div class="rp-r-0">{scope.row.changeStatePerson}</div>;
                  },
                },
              }}
            />
            <el-table-column
              prop="changeStateTimeStr"
              label="上下架时间"
              align="center"
              width="120px"
              sortable
              show-overflow-tooltip
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <div class="rp-r-0">{scope.row.changeStateTimeStr}</div>;
                  },
                },
              }}
            />
            <el-table-column
              prop="LineStr"
              label="上下架类型"
              align="center"
              width="120px"
              show-overflow-tooltip
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <div class="rp-r-0">{scope.row.LineStr}</div>;
                  },
                },
              }}
            />
            <el-table-column
              prop="updatePerson"
              label="更新人"
              align="center"
              width="120px"
              show-overflow-tooltip
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <div class="rp-r-0">{scope.row.updatePerson}</div>;
                  },
                },
              }}
            />
            <el-table-column
              prop="updateTimeStr"
              label="更新时间"
              align="left"
              width="250px"
              sortable
              show-overflow-tooltip
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <div class="rp-l-10 rp-r-0">{scope.row.updateTimeStr}</div>;
                  },
                },
              }}
            />
            <el-table-column
              prop=""
              label="操作"
              align="center"
              width="180px"
              fixed="right"
              {...{
                scopedSlots: {
                  default: (scoped) => {
                    return this.renderTableBtn(h, scoped.row);
                  },
                },
              }}
            />
          </el-table>
          <div class="bottomWrapper">
            {(this.pType === 1 || this.pType === 2) && (
              <el-button
                type="primary"
                disabled={!this.tableSelected || !this.tableSelected.length}
                onClick={this.batchAble.bind(
                  this,
                  0,
                  this.tableSelected.map(v => v.productId),
                )}>
                下架
              </el-button>
            )}
            {this.pType === 0 && (
              <el-button
                type="primary"
                disabled={!this.tableSelected || !this.tableSelected.length}
                onClick={this.batchAble.bind(
                  this,
                  1,
                  this.tableSelected.map(v => v.productId),
                )}>
                上架
              </el-button>
            )}
            {/* {this.pType === 9 && (
              <span
                class={[(!this.tableSelected || !this.tableSelected.length) && "disabled", "scopeSpan"]}
                onClick={this.batchSetClass.bind(this)}>
                批量设置分类
              </span>
            )} */}
            <span class={[(!this.tableSelected || !this.tableSelected.length) && 'disabled', 'scopeSpan']} onClick={this.batchDel.bind(this)}>
              删除
            </span>
            <span class="scopeSpan" onClick={this.updateProduct.bind(this)}>
              更新商品价格
            </span>
            <ExportFile export-text="下载为Excel" params={this.exportParams} http-type={'post'} is-button={false} service-url="adminExport"></ExportFile>
            <el-pagination
              on-size-change={this.onPageSizeChange}
              on-current-change={this.onPageChange}
              current-page={this.page}
              page-sizes={[10, 30, 60, 100]}
              pager-count={5}
              page-size={this.pageSize}
              layout="total, sizes, prev, pager, next, jumper"
              total={this.totalCount}
            />
          </div>
        </div>
      </div>
    );
  }
}
